import { useEffect, useRef, useState } from 'react';
import PersonnelFormFields from '../personnel/PersonnelFormFields';
import useAccountStore from '../../store/useAccountStore';

const QuickPersonnelModal = ({ onClose, onCreated }) => {
  const { getNextCode, saveAccount } = useAccountStore();
  const [form, setForm] = useState({ name: '', code: '', type: 'EMPLOYEE', employmentType: 'FIXED', personnelGroup: null, dailyRate: 0, currency: 'TRY', status: 'Active', phone: '', email: '', notes: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const submitting = useRef(false);
  useEffect(() => {
    let active = true;
    getNextCode('EMPLOYEE').then((code) => { if (active) setForm((prev) => ({ ...prev, code: prev.code || code })); });
    return () => { active = false; };
  }, [getNextCode]);
  const submit = async (event) => {
    event.preventDefault();
    if (submitting.current) return;
    submitting.current = true;
    setSaving(true);
    setError('');
    const result = await saveAccount({ ...form, type: 'EMPLOYEE' });
    if (result.success) onCreated(result.data);
    else setError(result.message || 'Personel oluşturulamadı.');
    submitting.current = false;
    setSaving(false);
  };
  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-slate-950/60 p-4">
      <div role="dialog" aria-modal="true" aria-labelledby="quick-personnel-title" className="max-h-[90vh] w-full max-w-3xl overflow-auto rounded-3xl bg-white p-6">
        <div className="mb-4 flex justify-between"><h2 id="quick-personnel-title" className="text-xl font-black">Yeni Personel Oluştur</h2><button type="button" disabled={saving} onClick={onClose}>Kapat</button></div>
        <form onSubmit={submit}>
          <fieldset disabled={saving}><PersonnelFormFields formData={form} setFormData={setForm} /></fieldset>
          {error && <p role="alert" className="mt-4 text-red-600">{error}</p>}
          <button disabled={saving} className="mt-4 rounded-xl bg-blue-600 px-6 py-3 font-bold text-white">{saving ? 'Kaydediliyor...' : 'Kaydet ve Seç'}</button>
        </form>
      </div>
    </div>
  );
};

export default QuickPersonnelModal;
